<template>
    <v-card>
      <v-card-title>
        <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
        {{ $lang('bills.fields.details') }}
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="detail.description"
          :label="$lang('bills.fields.description')"
          rows="1"
        />
        <v-text-field
          v-model="detail.vat_type"
          :label="$lang('bills.fields.vat_type')"
          type="number"
          suffix="%"
        />
        <v-select
          v-if="detail.vat_type == 0"
          v-model="detail.vat_exclusion_it"
          :label="$lang('bills.labels.vat_exclusion')"
          :items="$in('ConstInvoiceVatExclusionIT')"
        />
        <v-text-field
          v-model="detail.amount"
          :label="$lang('bills.fields.amount')"
          type="number"
          append-icon="mdi-cash"
        />
        <v-select
          v-model="detail.type"
          :label="$lang('bills.fields.type')"
          :items="$in('ConstDetailRowTypes')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('save', detail)" color="primary">{{ $lang('main.crud.save') }}</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
export default {
  name: 'RowDetail',
  props: {
    detail: {
      required: true,
    }
  }
}
</script>